import { render } from "./CategoryLinksComponent.vue?vue&type=template&id=58d848bc&scoped=true"
import script from "./CategoryLinksComponent.vue?vue&type=script&lang=js"
export * from "./CategoryLinksComponent.vue?vue&type=script&lang=js"

import "./CategoryLinksComponent.vue?vue&type=style&index=0&id=58d848bc&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d848bc"]])

export default __exports__